import {
    LocationAction,
    LocationActionTypes,
    SearchLocation
} from "../interfaces/context/searchContextInterfaces";

const defaultState = {
    userInputValue: "",
    userSelectedLocation: null,
    locationSuggestions: []
};

export const locationReducer = (state: SearchLocation, action: LocationAction) => {
    const defaultLocation = {
        label: "", latitude: null, longitude: null, value: "", remote_work_location_type: null
    };

    switch (action.type) {
    case LocationActionTypes.updateLocation: {
        let userInputValue = action.payload?.userInputValue === "" ? "" : action.payload.userInputValue;
        let userSelectedLocation = action.payload?.userSelectedLocation || defaultLocation;
        if (action.payload?.userInputValue === "Flexible / Remote") {
            userInputValue = "Remote / Flexible";
        }

        if (action.payload?.userSelectedLocation?.value === "Flexible / Remote") {
            userSelectedLocation = {
                label: "Remote / Flexible",
                latitude: null,
                longitude: null,
                value: "Remote / Flexible",
                remote_work_location_type: "virtual",
            };
        }
        return {
            ...state,
            userInputValue,
            userSelectedLocation,
        };
    }
    case LocationActionTypes.updateLocationSuggestions: {
        const updatedState = {
            ...state,
            locationSuggestions: action.payload.locationSuggestions
        };
        return updatedState;
    }
    case LocationActionTypes.resetLocation: {
        return defaultState;
    }
    default: {
        return state;
    }
    }
};
